/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Tooltip_ReingestInputs */

const es_settings_files_tooltip_reingest = /** @type {(inputs: Settings_Files_Tooltip_ReingestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Re-ingestar archivo`)
};

const en_settings_files_tooltip_reingest = /** @type {(inputs: Settings_Files_Tooltip_ReingestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Re-ingest file`)
};

/**
* | output |
* | --- |
* | "Re-ingest file" |
*
* @param {Settings_Files_Tooltip_ReingestInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_tooltip_reingest = /** @type {((inputs?: Settings_Files_Tooltip_ReingestInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Tooltip_ReingestInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_tooltip_reingest(inputs)
	return en_settings_files_tooltip_reingest(inputs)
});
export { settings_files_tooltip_reingest as "settings.files.tooltip.reingest" }